import ConciliacionSII from "../../components/ConciliacionSII";

const ConciliacionSIIPage = () => <ConciliacionSII />;

export default ConciliacionSIIPage;
